module.exports = __webpack_public_path__ + "static/media/alfred_logo.c3508d40.jpg";